<template>
  <div>
    <ButtonView type="normal" :color="errors ? 'warning' : 'secondary'" size="small" class="w-100" @click="open = !open">
      <div v-if="confirmedCondition" class="d-flex align-items-center justify-content-between g-2">
        <span>{{ confirmedCondition.title }}</span>
        <i v-if="confirmedCondition.icon" :class="confirmedCondition.icon"></i>
      </div>
      <div v-else>
        {{ translate('please_select') }}
      </div>
    </ButtonView>
    <ModalView v-model:active="open">
      <template v-slot:body>
        <div class="d-flex flex-column g-4">
          <div class="d-flex align-items-center justify-content-between">
            <h3 class="mb-0">{{ translate("automation.condition") }}</h3>
            <ModalCloseButtonView @click="open = false"/>
          </div>
          <div class="list-group">
            <div v-for="condition in filteredConditions" :key="condition.key" class="list-group-item list-group-item-action" @click="selectCondition(condition)" :class="{ active: selectedCondition === condition.key }">
              <div class="d-flex justify-content-between align-items-center">
                <span>{{ condition.title }}</span>
                <span v-if="condition.icon" class="bg-secondary rounded-2 px-2 py-1 small">
                  <i :class="condition.icon"></i>
                </span>
              </div>
            </div>
          </div>
          <ButtonView type="normal" color="secondary" @click="open = false">
            {{ translate("cancel") }}
          </ButtonView>
        </div>
      </template>
    </ModalView>
  </div>
</template>

<script>
import {ModalView, ModalCloseButtonView, ButtonView} from "@niftybit/vue";

export default {
  name: "ConditionSelectionView",
  components: {ModalView, ButtonView, ModalCloseButtonView},
  props: {
    value: String,
    outputType: Object,
    conditions: Array,
    errors: Array
  },
  emits: ["update:value"],
  data() {
    return {
      open: false,
      selectedCondition: this.value
    }
  },
  watch: {
    value() {
      if (this.selectedCondition !== this.value) this.selectedCondition = this.value;
    }
  },
  computed: {
    confirmedCondition() {
      return this.value ? this.conditions.find(item => item.key === this.value) : undefined;
    },
    filteredConditions() {
      return this.conditions.filter(item => item.dataTypes.includes(this.outputType.key));
    }
  },
  methods: {
    selectCondition(condition) {
      this.$emit("update:value", condition.key);
      this.open = false;
    }
  }
}
</script>

<style scoped>

</style>